export const resolveOrderEmail = (locationState = {}, userDetails = {}, savedUserDetails = {}) => {
  const rawStateEmail = locationState?.email;
  const rawUserEmail = userDetails?.email;
  const rawSavedEmail = savedUserDetails?.email;

  const candidates = [rawStateEmail, rawUserEmail, rawSavedEmail];
  const email = candidates
    .map(value => typeof value === 'string' ? value.trim() : '')
    .find(value => value.length > 0);

  return email || '';
};
